import React from 'react';
import DOMPurify from 'dompurify';

const HTML_TAG_RE = /<[a-z][\s\S]*?>/i;

export default function RichTextDisplay({ content, style, className }) {
  if (!content) return null;

  // If it contains HTML tags, sanitize and render as HTML
  if (HTML_TAG_RE.test(content)) {
    const clean = DOMPurify.sanitize(content, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'ul', 'ol', 'li',
                     'a', 'code', 'pre', 'blockquote', 'h1', 'h2', 'h3'],
      ALLOWED_ATTR: ['href', 'target', 'rel'],
      FORCE_HTTPS: false,
    });
    return (
      <div
        className={`rich-text-content${className ? ' ' + className : ''}`}
        style={style}
        dangerouslySetInnerHTML={{ __html: clean }}
      />
    );
  }

  // Plain text fallback (legacy content)
  return (
    <div
      className={className}
      style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', ...style }}
    >
      {content}
    </div>
  );
}
